<template>
    <div class="condition-content">
        <compare-value
            ref="compare"
            :input-placeholder="$t('请选择日期')"
            input-unit=""
            input-type="date"
            selector-type="TIME_POINT"
            :valid="valid"
            :value="currentValue"
            @change="onChange"
        />
    </div>
</template>

<script>
import CompareValue from './template/compare-value';
import { dateRule, dateText } from './formaterUtils';

export default {
  name: 'StorageTime',

  components: {
    CompareValue,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },

  data() {
    let currentValue = this.value;
    if (!this.value || !this.value.value) {
      currentValue = {
        operand: '==',
        value: null,
      };
    }
    return {
      currentValue,
      valid: true,
    };
  },
  computed: {
    brief() {
      return `${this.optionInfo.text}${dateText(this.currentValue, this.$refs)}`;
    },
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue || [];
    },
  },
  mounted() {
    this.onChange(this.currentValue);
  },

  methods: {
    validate() {
      this.valid = !!this.currentValue.value.startValue;
      return this.valid;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const ruleData = dateRule(this.currentValue, 'storageTime');
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: !!(showVal.value.startValue && showVal.value.endValue),
      });
    },
  },
};
</script>
